import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import isMountedMixin from 'vue/mixins/is-mounted';


const BOUNDARY_STRUCT = Object.seal({
    top: null,
    bottom: null,
});

const VIEWPORT_STRUCT = Object.seal({
    isBefore: {
        vp: cloneDeep(BOUNDARY_STRUCT),
    },
    isAfter: {
        vp: cloneDeep(BOUNDARY_STRUCT),
    },
    isWithin: {
        vp: null,
    },
});

const COMPARISON_STRUCT = Object.seal({
    el: {
        top: cloneDeep(VIEWPORT_STRUCT),
        bottom: cloneDeep(VIEWPORT_STRUCT),
        isWithin: {
            vp: {
                fully: null,
            },
        },
    },
});


export default {
    mixins: [
        isMountedMixin,
    ],
    computed: {
        ...mapGetters(['scroll', 'viewport']),
        boundaries() {
            let r = cloneDeep(COMPARISON_STRUCT);
            const { top, bottom } = this.elementConstraints;
            const { position: y } = this.scroll;
            const { height: h } = this.viewport;

            if ([top, bottom, y, h].filter(val => val == null).length) {
                return r;
            }

            r.el.top.isBefore.vp.top = (y > top);
            r.el.top.isBefore.vp.bottom = (y + h > top);
            r.el.top.isAfter.vp.top = !r.el.top.isBefore.vp.top;
            r.el.top.isAfter.vp.bottom = !r.el.top.isBefore.vp.bottom;
            r.el.top.isWithin.vp = (r.el.top.isAfter.vp.top && r.el.top.isBefore.vp.bottom);

            r.el.bottom.isBefore.vp.top = (y > bottom);
            r.el.bottom.isBefore.vp.bottom = (y + h > bottom);
            r.el.bottom.isAfter.vp.top = !r.el.bottom.isBefore.vp.top;
            r.el.bottom.isAfter.vp.bottom = !r.el.bottom.isBefore.vp.bottom;
            r.el.bottom.isWithin.vp = (r.el.bottom.isAfter.vp.top && r.el.bottom.isBefore.vp.bottom);

            r.el.isWithin.vp.fully = r.el.top.isAfter.vp.top && r.el.bottom.isBefore.vp.bottom;

            return r;
        },
        elementConstraints() {
            if (!this.isMounted || !this.viewport.height) {
                return {};
            }

            // TODO: We might be able to get rid of `getBoundingClientRect`, which is performance intensive
            const { top, height } = this.$el.getBoundingClientRect();
            const y = this.scroll.position;

            return {
                top: top + y,
                height,
                bottom: top + y + height,
            };
        },
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/viewport-boundaries/index.js